/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
    unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
    active-text-color="#ffd04b">
    <div class="logobox">
      <div :class="collapsed ? 'logoimg_small':'logoimg_big'"></div>
    </div>
    <el-submenu v-for="(menu,index) in $store.state.menulist" :key="index" :index="menu.module_code">
      <template slot="title">
        <i v-if="menu.icon_url" :class="menu.icon_url"></i>
        <span>{{menu.module_name}}</span>
      </template>
      <el-menu-item-group>
        <!-- 开放三级菜单需添加条件判断 -- v-if="!chmenu.children" -->
        <el-menu-item v-for="(chmenu,idx) in menu.modulelist" :index="'/'+chmenu.route" :key="idx">
          <i v-if="chmenu.icon_url" :class="chmenu.icon_url"></i>
          <span>{{chmenu.module_name}}</span>
        </el-menu-item>
        <!-- 未开放三级菜单 -->
        <!-- <el-submenu v-else v-for="chmenu in menu.modulelist" :index="'/'+chmenu.route" :key="chmenu.menuid">
          <template slot="title">
            <i class="iconfont" :class="chmenu.icon"></i>
            <span>{{chmenu.module_name}}22</span>
          </template>
          <el-menu-item-group>
            <el-menu-item v-for="chmenus in chmenu.modulelist" :index="'/'+chmenus.route" :key="chmenus.menuid">
              <i class="iconfont" :class="chmenus.icon"></i>
              <span>{{chmenus.module_name}}</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu> -->
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
  var rules = [];
  export default {
    name: 'leftnav',
    data() {
      return {
        collapsed: false,
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      // 监听
      this.$root.Bus.$on('toggle', value => {
        this.collapsed = !value
      })
    }
  }
</script>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
  }

  .el-menu-item-group__title {
    padding: 0px;
  }

  .el-menu-bg {
    background-color: #1f2d3d !important;
  }

  .el-menu {
    border: none;
  }

  .logobox {
    height: 40px;
    line-height: 40px;
    color: #9d9d9d;
    font-size: 20px;
    text-align: center;
    padding: 20px 0px;
  }

  .logoimg_big {
    height: 35px;
    background: url(../assets/img/logo-1.png) center no-repeat;
    background-size: 90px;
  }

  .logoimg_small {
    width: 30px;
    height: 30px;
    background: url(../assets/img/logo-2.png) center no-repeat;
    background-size: 25px;
    margin-left: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue